import { render, staticRenderFns } from "./UploadDocModal.vue?vue&type=template&id=298ad6a3&"
import script from "./UploadDocModal.vue?vue&type=script&lang=js&"
export * from "./UploadDocModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports